import { isNotNil } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { getRetrieve, useConfig } from '../../state/configuration'
import { AppPath } from '../AppPath'
import { AnonymousPrincipal } from '../authentication'
import { RetrieveFactory } from './RetrieveFactory'
import { RetrievePage } from './RetrievePage'
import { RetrievePath } from './RetrievePath'
import { RetrieveProposalPage } from './RetrieveProposalPage'

export interface RetrieveRouterProps {
  principal: AnonymousPrincipal
}

export const RetrieveRouter: FunctionComponent<RetrieveRouterProps> = ({ principal }) => {
  const retrieve = useConfig(getRetrieve)

  return isNotNil(retrieve) ? (
    <Routes>
      <Route
        index
        element={<RetrieveFactory config={retrieve} principal={principal} />}
      />

      {retrieve?.backBooks?.map((backBook) => (
        <Route
          key={backBook}
          path={backBook}
          element={<RetrievePage tName={backBook} principal={principal} />}
        />
      ))}

      <Route path={RetrievePath.RETRIEVE_PROPOSAL} element={<RetrieveProposalPage />} />

      <Route path='*' element={<Navigate to={AppPath.HOME} />} />
    </Routes>
  ) : null
}
